import actions from "./actions";
import state from "./state";
import mutations from "./mutations";

const getters = {
  getStaffClockRecordList: (state) => state.items,
  getStaffClockRecordPagination: (state) => state.pagination,
  getStaffClockRecordPage: (state) => state.pagination.current_page,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
